import { render, staticRenderFns } from "./EditRect.vue?vue&type=template&id=40a6791f&scoped=true&"
import script from "./EditRect.vue?vue&type=script&lang=js&"
export * from "./EditRect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a6791f",
  null
  
)

export default component.exports